<template>
  <div>
    <!-- Form -->

    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Account Name *"
                  v-model="formSchema.eco_account_name"
                  :rules="[v => !!v || 'Account name is required !',lng100]"
                  required
                ></v-text-field>
              </v-flex>     

              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Account Number *"
                  v-model="formSchema.eco_account_code"
                  :rules="[v => !!v || 'Account code is required !',lng30]"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Account With"
                  v-model="formSchema.account_with"
                  :rules="[lng100]"
                ></v-text-field>
              </v-flex>
             
              <input type="hidden" v-model="formSchema.account_type" value="Repayment Account">         

              <v-flex xs12 sm6 md4>
                <v-select
                  label="Currency"
                  v-model="formSchema.operating_currency"
                  :items="['USD','BDT']"
                  required
                ></v-select>
              </v-flex> 

              <!--  <v-flex xs12 sm6 md4>
                <v-select
                  label="Category"
                  v-model="formSchema.category"
                  :items="categoryList"
                  required
                ></v-select>
              </v-flex>    -->

              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Remarks"
                  v-model="formSchema.remarks"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                Upload File
                <input
                  type="file"
                  id="files2"
                  ref="image2"
                  v-on:change="handleFilesUpload()"
                />
              </v-flex>

              <v-flex xs12 sm6 md4>
               <v-textarea
               label="Address"
               v-model="formSchema.address"
               ></v-textarea>
             </v-flex>

              

             <v-flex xs12 sm6 md4>
                <v-checkbox v-model="formSchema.is_active" label="Active" :value="isActiveVal"></v-checkbox>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
            <v-icon>save</v-icon>
            {{addUpdateBtn}}
          </v-btn>
          <v-btn color="error" @click.native="$refs.form.reset" @click="resetForm">
            <v-icon>refresh</v-icon>Reset
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service");
let utilities = require("../../../utilities/utilities");

export default {
  props: ["formSchema"],

  data: () => ({
    valid: true,
    isActiveVal:1,    
    accountTypeList: utilities.getAccountTypeList('account'),
    categoryList:[
    'IDA',
    'GOB',    
    ],
        
    documentFiles:[],    

    SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0
        ? "Edit Repayment Account Information"
        : "Add Repayment Account Information";
    },
    addUpdateBtn() {
      return this.formSchema.id > 0
        ? "Update"
        : "Save";
    }
  },

  methods: {
    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
    },

    validateBeforeSubmit(e) {

      let formData = new FormData();
      var formSchema = this.formSchema;      

      for (var i = 0; i < this.documentFiles.length; i++) {
        let file = this.documentFiles[i];
        formData.append("files[" + i + "]", file);
      } 

      formData.append("fieldValues", JSON.stringify(formSchema));

      let docInfor = {
        "record_id":sessionStorage.getItem("mm_id"),
        "sub_menu_id":sessionStorage.getItem("sm_id"),
      };
      formData.append("documentInfo", JSON.stringify(docInfor));
      formData.append("listFor", 'onLending');

      if (this.$refs.form.validate()) {
          commonService
            .insertFormData(formData, "account-info")
            .then(res => {
              let actionData = {
                message: res.message,
                data: res.data,
                action: res.action,
                status: res.status
              };
              document.getElementById("files2").value = null;
              this.close(actionData);
            });
      }
    },
    
    handleFilesUpload() {
      let uploadedFiles = this.$refs.image2.files;
      let fileExtension = uploadedFiles[0].name.replace(/^.*\./, "");
      //console.log("fileExtension", fileExtension);

      let allowedExtensions = /(\.jpg|\.JPG|\.jpeg|\.JPEG|\.png|\.PNG|\.pdf|\.PDF|\.doc|\.docx)$/i;
      if (!allowedExtensions.exec(uploadedFiles[0].name)) {

       this.SnackbarVal.message = "You can upload jpg, jpeg, png, pdf and docx file only";
       this.SnackbarVal.snackbar = true;
       this.SnackbarVal.color = 'error';

        this.$refs.image2.value = "";
        this.documentFiles = [];
      } else {
        //console.log("uploadedFiles[i] = ", uploadedFiles[0]);

        this.documentFiles = uploadedFiles;

        // for (var i = 0; i < uploadedFiles.length; i++) {
        //   this.documentFiles.push(uploadedFiles[i]);
        // }
      }
    },

    resetForm(){
      this.formSchema.id = 0;      
    },

    close: function(data) {
      if (data.status == 1) {
        this.$refs.form.reset();
        this.formSchema.id = 0;
      }
      this.$emit("emitForm", data);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/lending/account_info/insertForm.vue